var map = {
	"./en-US.json": "./src/translations/en-US.json",
	"./es-PE.json": "./src/translations/es-PE.json",
	"./pt-BR.json": "./src/translations/pt-BR.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/translations sync recursive ^\\.\\/.*\\.json$";